export default "__VITE_ASSET__E6JF22_K__"